var _path, _path2, _rect, _g, _rect2, _rect3, _rect4, _rect5, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCertificationNew3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 149,
    viewBox: "0 0 218 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.7386 30.75C93.7386 24.6749 98.6635 19.75 104.739 19.75H184.511V137.395C184.511 143.47 179.587 148.395 173.511 148.395H93.7386V30.75Z",
    fill: "#FFCF85"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M179.101 19.75H185.534C191.61 19.75 196.534 24.6749 196.534 30.75V63.4542C196.534 69.5293 191.61 74.4542 185.534 74.4542H179.101V19.75Z",
    fill: "#FFCF85"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 109.368,
    y: 40.7891,
    width: 59.5134,
    height: 16.2309,
    fill: "#FFF2DE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2723_1323)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21,
    width: 100.088,
    height: 132.713,
    rx: 4,
    fill: "#F4F4F4"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 38.4331,
    y: 58.8047,
    width: 65.2504,
    height: 3.3063,
    rx: 1.65315,
    fill: "#DFDFDF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 38.4331,
    y: 71.1094,
    width: 65.2504,
    height: 3.3063,
    rx: 1.65315,
    fill: "#DFDFDF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38.4331,
    y: 83.4141,
    width: 65.2504,
    height: 3.3063,
    rx: 1.65315,
    fill: "#DFDFDF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 38.4331,
    y: 95.7266,
    width: 46.8893,
    height: 3.3063,
    rx: 1.65315,
    fill: "#DFDFDF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8535 32.6543C53.8472 34.5205 54.812 36.52 56.748 37.3262L55.8721 38.5957C54.5137 38.0181 53.5742 36.8691 53.0537 35.4727C52.5332 36.9897 51.5747 38.2593 50.21 38.8877L49.2832 37.6055C51.2002 36.7485 52.1904 34.6094 52.1904 32.6543V31.9434H49.7402V30.623H56.2656V31.9434H53.8535V32.6543ZM57.4082 41.0586V29.5059H59.0459V41.0586H57.4082ZM63.4639 36.082V37.3135H68.2754V36.082H69.875V40.9316H61.877V36.082H63.4639ZM60.6074 35.3203V34.0254H68.0469C68.269 32.9082 68.3008 32.0449 68.3135 31.2705H61.9023V29.9756H69.9258V30.9023C69.9321 31.7783 69.9321 32.7114 69.6528 34.0254H71.1826V35.3203H60.6074ZM63.4639 39.624H68.2754V38.5449H63.4639V39.624ZM81.5801 29.5059V36.2725H79.9678V34.7998H77.8096V35.6377H72.3252V30.3564H77.8096V31.1943H79.9678V29.5059H81.5801ZM73.6582 38.8242C73.6582 37.4023 75.1689 36.5708 77.6318 36.5771C80.1011 36.5708 81.6118 37.4023 81.6182 38.8242C81.6118 40.2524 80.1011 41.0649 77.6318 41.0586C75.1689 41.0649 73.6582 40.2524 73.6582 38.8242ZM73.9375 34.3555H76.2227V31.6387H73.9375V34.3555ZM75.2705 38.8242C75.2705 39.4844 76.1021 39.8271 77.6318 39.8271C79.168 39.8271 79.9995 39.4844 80.0059 38.8242C79.9995 38.1387 79.168 37.8086 77.6318 37.8086C76.1021 37.8086 75.2705 38.1387 75.2705 38.8242ZM77.8096 33.4922H79.9678V32.4766H77.8096V33.4922ZM88.626 30.1025V33.6953H85.1348V34.8569C86.8486 34.8442 87.877 34.7871 89.0449 34.584L89.1973 35.8789C87.8452 36.1265 86.6328 36.1709 84.3984 36.1709H83.5352V32.4766H87.0137V31.4102H83.5098V30.1025H88.626ZM84.8936 38.9258C84.8936 37.542 86.4043 36.7231 88.8926 36.7295C91.3618 36.7231 92.8662 37.542 92.8789 38.9258C92.8662 40.3096 91.3618 41.103 88.8926 41.0967C86.4043 41.103 84.8936 40.3096 84.8936 38.9258ZM86.5439 38.9258C86.5312 39.5605 87.3374 39.8652 88.8926 39.8652C90.4287 39.8652 91.2603 39.5605 91.2666 38.9258C91.2603 38.272 90.4287 37.9609 88.8926 37.9609C87.3374 37.9609 86.5312 38.272 86.5439 38.9258ZM89.2988 34.7363V33.4414H91.1904V32.3623H89.2988V31.0547H91.1904V29.5186H92.8154V36.5391H91.1904V34.7363H89.2988Z",
    fill: "#374969"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2723_1323",
    x: 21,
    y: 0,
    width: 108.087,
    height: 140.711,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2723_1323"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2723_1323",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCertificationNew3);
export default __webpack_public_path__ + "static/media/IcCertificationNew3.120e866a00d62bf0083733ed1fd2c03a.svg";
export { ForwardRef as ReactComponent };